module.exports = __webpack_public_path__ + "img/SES_500280010.dc45f6c2.jpg";